/**
 * pz-region-filter.js — поиск не показывает товары, недоступные в стране
 * покупателя (бриф briefregionsearchfilter, зелёный свет 2026-08-01).
 *
 * Правило (владелец): товар виден из страны C, если C не в region_block И
 * (C в region_allow ИЛИ region_allow несёт сентинел "ALL"). Поля в записях
 * индекса лежат по пути meta.custom.region_allow / meta.custom.region_block
 * (проверено живым запросом 2026-08-01: боевое правило для UA отдаёт 7 986
 * из 9 703; короткий путь без meta. — 0).
 *
 * Это UX-фильтр поиска, не защита доступа: он лишь убирает из выдачи
 * клики в страницу ошибки.
 *
 * Фильтруются ОБЕ поверхности: автокомплит и страница результатов
 * (этап 2 включён 2026-08-01 после заливки filterOnly-фасетов region_*
 * во все сортировочные реплики; проверено REST-ом: боевое правило на
 * recently_ordered_count_desc / price_ratio_asc / published_at_desc
 * отдаёт 7 986, а не «молча ноль», как было без фасетов. Фильтр по
 * атрибуту без фасета Algolia отрабатывает МОЛЧА В НОЛЬ — потому этап 2
 * и ждал реплики).
 *
 * Регистрация обязана случиться ДО инициализации приложения Algolia:
 * FiltersString читается при сборке плагина, а не на каждый запрос
 * (проверено: хук, зарегистрированный после загрузки, не вызывается).
 * Скрипт стоит в theme.liquid с defer — выполняется до DOMContentLoaded,
 * то есть до init приложения.
 */
(function () {
  var SENTINEL_ALL = 'ALL';
  var ALLOW_FIELD = 'meta.custom.region_allow';
  var BLOCK_FIELD = 'meta.custom.region_block';
  // Второй «пропуск» (2026-08-03): публикация на рынок. Поле пишет
  // market_distribution — страны рынков, где товар СНЯТ с публикации
  // (клик по такому хиту = 404 страны покупателя; замер: ~24% топа UA).
  // Инверсная семантика решает страну БЕЗ рынка по построению: её кода
  // нет ни в одном значении поля → NOT пропускает всё, JS не знает
  // карты рынков. Отсутствие поля у записи = «нигде не исключён».
  var MARKET_BLOCK_FIELD = 'meta.custom.market_block';

  function regionFilter(existing) {
    var country = ((window.Shopify && window.Shopify.country) || '')
      .toUpperCase();
    // страна неизвестна или не ISO2 — не фильтруем (показать всё честнее,
    // чем спрятать всё)
    if (!/^[A-Z]{2}$/.test(country)) return existing;
    var region = '(' + ALLOW_FIELD + ':"' + country + '" OR '
      + ALLOW_FIELD + ':"' + SENTINEL_ALL + '")'
      + ' AND NOT ' + BLOCK_FIELD + ':"' + country + '"'
      + ' AND NOT ' + MARKET_BLOCK_FIELD + ':"' + country + '"';
    return (existing && existing.trim())
      ? '(' + existing + ') AND ' + region
      : region;
  }

  // Публичная точка для соседей темы: догрузка строк в панели подсказок
  // (algolia-search-modal.js) обязана слать ТО ЖЕ правило страны, что и
  // сами подсказки, — иначе догруженное показало бы недоступные товары.
  window.pzRegionFilter = regionFilter;

  function register() {
    var hooks = window.algoliaShopify && window.algoliaShopify.hooks;
    if (!hooks || typeof hooks.registerHook !== 'function') return false;
    hooks.registerHook('beforeAutocompleteFiltersString', regionFilter);
    hooks.registerHook('beforeInstantSearchFiltersString', regionFilter);
    return true;
  }

  // Приложение может собрать hooks-API позже нашего defer-скрипта —
  // тогда регистрируем по его же событию (паттерн algolia_custom_hooks).
  if (!register()) {
    document.addEventListener('algolia.hooks.initialize', register);
  }
})();
